export enum VeteranStatusEnum {
    USArmy = "US Army",
    MarineCorps = "Marine Corps",
    Navy = "Navy",
    AirForce = "Air Force",
    SpaceForce = "Space Force",
    CoastGuards = "Coast Guards"
}